"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useQuickOrderForm = void 0;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailed = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var _analyticsData = require("@ori/analytics-data");
var _i18n = require("@ori/i18n");
var _downshift = _interopRequireDefault(require("downshift"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _react = require("react");
var _api = require("../api");
var _contexts = require("../contexts");
var _logger = require("../logger");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const DEBOUNCE_TIMEOUT = 350;
const INVALID_PRODUCT_CODE_CHARACTERS = [
    'E',
    'e',
    '.',
    '+',
    '-'
];
const USER_CANCEL_MESSAGE = 'User closed the loyalty dialog.';
const hookName = 'useQuickOrderForm';
const addToBasket = async (param)=>{
    let { itemCode, name, quantity, price } = param;
    return new Promise((resolve, reject)=>{
        function handleResolve() {
            window.removeEventListener(BasketUpdated.Name, handleResolve);
            window.removeEventListener(AddToBasketFailed.Name, handleReject);
            window.removeEventListener(LoyaltyDialogResult.Name, handleLoyaltyDialogSelection);
            (0, _logger.logInfo)("".concat(hookName, ": addToBasket action success."));
            resolve();
        }
        function handleReject(e) {
            window.removeEventListener(AddToBasketFailed.Name, handleReject);
            window.removeEventListener(BasketUpdated.Name, handleResolve);
            window.removeEventListener(LoyaltyDialogResult.Name, handleLoyaltyDialogSelection);
            reject(e.detail.localizedMessage);
        }
        function handleLoyaltyDialogSelection(e) {
            window.removeEventListener(LoyaltyDialogResult.Name, handleLoyaltyDialogSelection);
            const { result } = e.detail;
            if (LoyaltyDialogResult.isLoyaltyCloseResult(result)) {
                reject(new Error(USER_CANCEL_MESSAGE));
            } else {
                resolve();
            }
        }
        window.addEventListener(LoyaltyDialogResult.Name, handleLoyaltyDialogSelection);
        window.addEventListener(BasketUpdated.Name, handleResolve);
        window.addEventListener(AddToBasketFailed.Name, handleReject);
        const [itemName] = name.split(' - ');
        const event = new CustomEvent(AddToBasket.Name, {
            detail: {
                itemCode,
                quantity: Number.parseInt(quantity, 10),
                localName: itemName !== null && itemName !== void 0 ? itemName : '',
                globalName: '',
                placement: _analyticsData.Placement.QuickOrderForm,
                price
            }
        });
        (0, _logger.logDebug)("".concat(hookName, ": addToBasket action called. Triggering event:"), event);
        window.dispatchEvent(event);
    });
};
const useQuickOrderForm = ()=>{
    var _foundProducts_;
    const { language } = (0, _i18n.useLanguage)();
    const { maxValue, minValue, defaultQty } = (0, _contexts.useCheckoutQuickOrderForm)();
    const [value, setValue] = (0, _react.useState)('');
    const [quantity, setQuantity] = (0, _react.useState)(String(defaultQty));
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const { foundProducts, isProductSearchLoading } = (0, _api.useProductSearchQuery)(value);
    const results = foundProducts;
    var _foundProducts__price;
    const price = (_foundProducts__price = (_foundProducts_ = foundProducts[0]) === null || _foundProducts_ === void 0 ? void 0 : _foundProducts_.price) !== null && _foundProducts__price !== void 0 ? _foundProducts__price : 0;
    const onStateChange = (0, _lodash.default)((param)=>{
        let { inputValue } = param;
        if (typeof inputValue === 'string') {
            setValue(inputValue);
        }
    }, DEBOUNCE_TIMEOUT);
    const input = (0, _react.useRef)(null);
    const isFormFocused = (param)=>{
        let { currentTarget, relatedTarget, type } = param;
        var _input_current_parentElement, _input_current;
        const formElement = (_input_current = input.current) === null || _input_current === void 0 ? void 0 : (_input_current_parentElement = _input_current.parentElement) === null || _input_current_parentElement === void 0 ? void 0 : _input_current_parentElement.parentElement;
        const element = type === 'blur' ? relatedTarget : currentTarget;
        return Boolean(formElement === null || formElement === void 0 ? void 0 : formElement.contains(element));
    };
    const normalizeQuantityValue = (0, _react.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- I'd rather not change the logic here
        if (!Number.parseInt(quantity, 10) || quantity === '') {
            setQuantity(String(defaultQty));
        }
    }, [
        quantity,
        defaultQty
    ]);
    const handleFocus = (0, _react.useCallback)((event)=>{
        const hasFocus = isFormFocused(event);
        (0, _logger.logDebug)('handleFocus - hasFocus:', hasFocus, '\n\t', event);
        setIsFocused(hasFocus);
    }, []);
    const handleQuantityBlur = (0, _react.useCallback)((event)=>{
        normalizeQuantityValue();
        const hasFocus = isFormFocused(event);
        (0, _logger.logDebug)('handleQuantityBlur - hasFocus:', hasFocus, '\n\t', event);
        setIsFocused(hasFocus);
    }, [
        normalizeQuantityValue
    ]);
    const setFocus = (0, _react.useCallback)(()=>{
        var _input_current;
        (_input_current = input.current) === null || _input_current === void 0 ? void 0 : _input_current.focus();
        setIsFocused(true);
    }, []);
    const handleAddToBasket = (0, _react.useCallback)(async (param)=>{
        let { clearSelection, itemCode, name, price: newPrice, quantity: newQuantity } = param;
        setIsLoading(true);
        try {
            await addToBasket({
                itemCode,
                name,
                quantity: newQuantity,
                price: newPrice
            });
            clearSelection(()=>{
                setValue('');
                setQuantity('1');
            });
        } catch (currentError) {
            if (currentError instanceof Error) {
                if (currentError.message !== USER_CANCEL_MESSAGE) {
                    _logger.mainLogger.error(currentError, {
                        action: 'handleAddToBasket'
                    });
                }
            } else {
                (0, _logger.logDebug)('error is not instance of error');
                const newError = new Error(String(currentError));
                _logger.mainLogger.error(newError, {
                    action: 'handleAddToBasket'
                });
            }
        }
        setIsLoading(false);
        setFocus();
    }, [
        setFocus
    ]);
    const handleButtonClick = (0, _react.useCallback)((clearSelection)=>{
        normalizeQuantityValue();
        void handleAddToBasket({
            clearSelection,
            itemCode: value,
            name: '',
            quantity: quantity || String(defaultQty),
            price
        });
    }, [
        normalizeQuantityValue,
        handleAddToBasket,
        value,
        quantity,
        defaultQty,
        price
    ]);
    const handleKeyDown = (0, _react.useCallback)((event)=>{
        const { key: pressedKey, currentTarget: { value: inputValue } } = event;
        if (pressedKey === 'Enter' && inputValue !== value) {
            setValue(inputValue);
            event.preventDefault();
        } else if (INVALID_PRODUCT_CODE_CHARACTERS.some((invalidCharacter)=>pressedKey === invalidCharacter)) {
            event.preventDefault();
        }
    }, [
        value
    ]);
    const handleChange = (0, _react.useCallback)((item, param)=>{
        let { clearSelection } = param;
        (0, _logger.logDebug)("".concat(hookName, ": handleChange called. Item:"), item);
        if (typeof (item === null || item === void 0 ? void 0 : item.value) !== 'undefined') {
            const { value: itemValue, name, price: newPrice } = item;
            const itemCode = String(itemValue);
            void handleAddToBasket({
                itemCode,
                name,
                quantity,
                clearSelection,
                price: newPrice
            });
        }
    }, [
        handleAddToBasket,
        quantity
    ]);
    const stateReducer = (0, _react.useCallback)((state, changes)=>{
        (0, _logger.logDebug)("".concat(hookName, ": stateReducer called. State:"), state, 'changes:', changes);
        let parsedValue;
        switch(changes.type){
            case _downshift.default.stateChangeTypes.blurInput:
            case _downshift.default.stateChangeTypes.mouseUp:
            case _downshift.default.stateChangeTypes.touchEnd:
                return {
                    ...changes,
                    inputValue: state.inputValue
                };
            case _downshift.default.stateChangeTypes.changeInput:
                var _changes_inputValue;
                parsedValue = Number.parseInt((_changes_inputValue = changes.inputValue) !== null && _changes_inputValue !== void 0 ? _changes_inputValue : '', 10);
                return {
                    ...changes,
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- I'd rather not change the logic here
                    inputValue: parsedValue || changes.inputValue === '' ? parsedValue.toString() || '' : state.inputValue
                };
            default:
                return changes;
        }
    }, []);
    const itemToString = (0, _react.useCallback)((item)=>item ? item.value.toString() : '', []);
    return {
        defaultQty,
        handleButtonClick,
        handleChange,
        handleFocus,
        handleKeyDown,
        handleQuantityBlur,
        input,
        isFocused,
        isLoading,
        isProductSearchLoading,
        itemToString,
        language,
        maxValue,
        minValue,
        onStateChange,
        quantity,
        results,
        setFocus,
        setQuantity,
        stateReducer,
        value
    };
};
exports.useQuickOrderForm = useQuickOrderForm;
